let ws
let reconnectAttempts = 0
let reconnectTimer = null
let heartbeatTimer = null
let manuallyClosed = false
const subscriptions = new Map() // храним все подписки
const messageHandlers = new Set() // несколько подписчиков на сообщения

const WS_URL = 'wss://backendtest.bigplay.gg/chat-test'
const HEARTBEAT_INTERVAL_MS = 25000
const MAX_RECONNECT_DELAY_MS = 30000

function clearReconnectTimer() {
    if (reconnectTimer) {
        clearTimeout(reconnectTimer)
        reconnectTimer = null
    }
}

function clearHeartbeat() {
    if (heartbeatTimer) {
        clearInterval(heartbeatTimer)
        heartbeatTimer = null
    }
}

function startHeartbeat() {
    clearHeartbeat()
    heartbeatTimer = setInterval(() => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            try {
                ws.send(JSON.stringify({cmd: 'ping'}))
            } catch (e) {
                console.error('WebSocket ping failed:', e)
            }
        }
    }, HEARTBEAT_INTERVAL_MS)
}

function scheduleReconnect() {
    if (manuallyClosed) return
    if (reconnectTimer) return

    const delay = Math.min(1000 * Math.pow(2, reconnectAttempts), MAX_RECONNECT_DELAY_MS)
    reconnectAttempts += 1
    console.log(`WebSocket: reconnect scheduled in ${delay}ms (attempt ${reconnectAttempts})`)

    reconnectTimer = setTimeout(() => {
        reconnectTimer = null
        connectToWs()
    }, delay)
}

export function connectToWs() {
    if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
        return ws
    }

    manuallyClosed = false
    ws = new WebSocket(WS_URL)

    ws.onopen = () => {
        console.log('WebSocket connected')
        reconnectAttempts = 0
        clearReconnectTimer()
        startHeartbeat()

        // Восстанавливаем/устанавливаем все подписки
        subscriptions.forEach((data, channel) => {
            try {
                ws.send(JSON.stringify({
                    cmd: 'subscribe',
                    channel,
                    data
                }))
            } catch (e) {
                console.error('WebSocket resubscribe failed:', e)
            }
        })
    }

    ws.onerror = (error) => {
        console.error('WebSocket error:', error)
    }

    ws.onclose = (event) => {
        console.warn(`WebSocket closed (code=${event.code}, reason=${event.reason || 'n/a'})`)
        clearHeartbeat()
        ws = null
        if (!manuallyClosed) {
            scheduleReconnect()
        }
    }

    ws.onmessage = (event) => {
        try {
            const data = JSON.parse(event.data)
            messageHandlers.forEach(handler => {
                try {
                    handler(data)
                } catch (err) {
                    console.error('WebSocket handler threw:', err)
                }
            })
        } catch (e) {
            console.error('Error parsing WebSocket message:', e)
        }
    }
    return ws
}

export function subscribe(channel, token) {
    subscriptions.set(channel, {token})
    if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({
            cmd: 'subscribe',
            channel,
            data: {token}
        }))
    } else {
        // Соединения нет — инициируем; onopen сам восстановит подписку из subscriptions
        connectToWs()
    }
}

export function unsubscribe(channel) {
    subscriptions.delete(channel)

    if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({
            cmd: 'unsubscribe',
            channel
        }))
    }
}

export function sendMessage(data) {
    if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify(data))
    }
}

// Регистрирует обработчик входящих сообщений. Возвращает функцию отписки.
// Несколько обработчиков могут быть зарегистрированы одновременно —
// каждый получит все сообщения и должен сам фильтровать по channel/event.
export function onMessage(callback) {
    messageHandlers.add(callback)
    return () => messageHandlers.delete(callback)
}

export function closeWs() {
    manuallyClosed = true
    clearReconnectTimer()
    clearHeartbeat()
    subscriptions.clear()
    messageHandlers.clear()
    if (ws) {
        ws.close()
        ws = null
    }
    reconnectAttempts = 0
}

// Ускоряем восстановление после «сна» вкладки/потери сети
if (typeof window !== 'undefined') {
    window.addEventListener('online', () => {
        if (!manuallyClosed && (!ws || ws.readyState === WebSocket.CLOSED)) {
            clearReconnectTimer()
            reconnectAttempts = 0
            connectToWs()
        }
    })
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible'
            && !manuallyClosed
            && (!ws || ws.readyState === WebSocket.CLOSED)) {
            clearReconnectTimer()
            reconnectAttempts = 0
            connectToWs()
        }
    })
}
